import Upload from "./upload/Upload";

export default Upload;